import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { LoadConsolePermissionGroupItemMaintenanceDto } from './LoadConsolePermissionGroupItemMaintenanceDto';
import { LoadConsolePermissionGroupListMaintenanceDto } from './LoadConsolePermissionGroupListMaintenanceDto';

@Injectable()
export class LoadConsolePermissionGroupSubMaintenanceController extends BaseSubMaintenanceController<LoadConsolePermissionGroupListMaintenanceDto, LoadConsolePermissionGroupItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "loadconsole/permissiongroup");
    }

    public getResourceRoot(): string {
        return "LOADCONSOLE.PERMISSION.GROUP";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/screensandforms/loadconsolesetting/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}